const DEFAULTS = {
  title: "拼豆物语｜在线拼豆图纸生成器",
  description: "上传图片生成拼豆图纸，支持品牌色号匹配、用豆统计、2D/3D 成品预览和作品分享。",
  image: "https://pindouwuyu.cn/logo.png",
  type: "website"
};

function ensureMeta(selector, attributes) {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement("meta");
    Object.entries(attributes).forEach(([key, value]) => element.setAttribute(key, value));
    document.head.appendChild(element);
  }
  return element;
}

function setMeta(selector, attributes, content) {
  ensureMeta(selector, attributes).setAttribute("content", content || "");
}

export function setPageSeo(options = {}) {
  const title = options.title || DEFAULTS.title;
  const description = options.description || DEFAULTS.description;
  const image = options.image || DEFAULTS.image;
  const url = options.url || window.location.href;
  const type = options.type || DEFAULTS.type;
  document.title = title;
  setMeta('meta[name="description"]', { name: "description" }, description);
  setMeta('meta[property="og:type"]', { property: "og:type" }, type);
  setMeta('meta[property="og:title"]', { property: "og:title" }, title);
  setMeta('meta[property="og:description"]', { property: "og:description" }, description);
  setMeta('meta[property="og:image"]', { property: "og:image" }, image);
  setMeta('meta[property="og:url"]', { property: "og:url" }, url);
  setMeta('meta[name="twitter:card"]', { name: "twitter:card" }, "summary_large_image");
  setMeta('meta[name="twitter:title"]', { name: "twitter:title" }, title);
  setMeta('meta[name="twitter:description"]', { name: "twitter:description" }, description);
  setMeta('meta[name="twitter:image"]', { name: "twitter:image" }, image);
  let canonical = document.head.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute("href", url.split("?")[0]);
}

export function setRouteSeo(route) {
  setPageSeo({
    title: `${route.meta?.title || "拼豆物语"} · 拼豆物语`,
    description: route.meta?.description || DEFAULTS.description,
    url: `${window.location.origin}${window.location.pathname}`
  });
}
